import { PriceIntervalEnum } from "@finway-group/shared/lib/models"
import { Card, Col, Row } from "antd"
import PriceLabel from "Components/priceLabel"
import React from "react"
import { useTranslation } from "react-i18next"
import { useCardOverviewData } from "Shared/hooks/analytics.hooks"
import { UserService } from "Shared/services"
import { BarChart } from "../../../components/barCharts"

export const CardWidget: React.FC<{}> = () => {
    const { t } = useTranslation()
    const globalCurrency = UserService.getLoggedInEmployeeProfile().settings.globalCurrency
    const overviewData = useCardOverviewData()

    return (
        <Row gutter={[16, 0]} className="mb-32">
            <Col span={24} md={12} lg={8}>
                <Card>
                    <Row className="mt-10 mb-0">
                        <h4 className="mb-0 truncate inline">{t("creditCard:card_widget.balance")}</h4>
                    </Row>
                    <Row>
                        <div className="mt-16">
                            <p className="text-2xl">
                                <PriceLabel currency={globalCurrency} interval={PriceIntervalEnum.ONE_TIME} value={overviewData?.walletBalance || 0} showFullNumber />
                            </p>
                        </div>
                    </Row>
                </Card>
            </Col>

            <Col span={24} md={12} lg={8}>
                <Card>
                    <Row className="mt-10 mb-0">
                        <h4 className="mb-0 truncate inline">{t("creditCard:card_widget.loaded_sum")}</h4>
                    </Row>
                    <Row>
                        <div className="mt-16">
                            <p className="text-2xl">
                                <PriceLabel currency={globalCurrency} interval={PriceIntervalEnum.ONE_TIME} value={overviewData?.totalCardBalance || 0} showFullNumber />
                            </p>
                        </div>
                    </Row>
                </Card>
            </Col>

            {/* <Col xs={24} md={8}>
                <Card>
                    <Row className="mt-10">
                        <i className="el-icon-coin mr-16"></i>
                        <h4 className="mb-0 truncate">{t('creditCard:card_widget.pending_transaction')}</h4>
                    </Row>
                    <Row>
                        <div className="w-1/2 mt-16">
                            <p className="text-2xl">
                                <PriceLabel currency={globalCurrency} interval={PriceIntervalEnum.ONE_TIME} value={1300} />
                            </p>
                        </div>
                        <div className="ml-auto mt-20">
                            <BarChart color="#FBAC3B" />
                        </div>
                    </Row>
                </Card> 
            </Col>*/}
        </Row>
    )
}

export default CardWidget
